document.addEventListener("DOMContentLoaded", () => {
  const wishlistRemoveButtons = document.querySelectorAll('.product-cellar-item__remove-button');
  const wishlistSaveButtons = document.querySelectorAll('.product-cellar-item__save-button');

  wishlistRemoveButtons.forEach(wishlistRemoveButton => wishlistRemoveButton.addEventListener('click', () => removeFromWishlist(event)));
  wishlistSaveButtons.forEach(wishlistSaveButton => wishlistSaveButton.addEventListener('click', () => saveToWishlist(event)));

  function removeFromWishlist(event) {
    event.preventDefault();

    let wishlistRemoveButton = event.target || event.srcElement;
    const variantId = wishlistRemoveButton.getAttribute("data-variant-id");
    const customerId = wishlistRemoveButton.getAttribute("data-customer-id");

    let url = `/a/account/${customerId}/cellar_items/destroy_by_variant`;
    let xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if(xhr.status === 400) {
          const responseJSON = JSON.parse(xhr.response);
          const errorsEl = document.getElementById(`product-cellar-item__errors-${variantId}`);
          errorsEl.style.display = "block";
          console.log(responseJSON.error);
          errorsEl.innerHTML = "Could not remove from wishlist";
        } else if(xhr.status === 200) {
          console.log("success");
         
          const wishlistAddButton = document.getElementById(`product-cellar-item__add-button-${variantId}`);

          wishlistRemoveButton.style.display = "none";
          wishlistAddButton.style.display = "flex";
        }

      }};

      let data = `{
        "shopify_variant_id": "${variantId}"
      }`;

      console.log(data);

      xhr.send(data);
  }

  function saveToWishlist(event) {
    event.preventDefault();

    let wishlistSaveButton = event.target || event.srcElement;
    const variantId = wishlistSaveButton.getAttribute("data-variant-id");
    const customerId = wishlistSaveButton.getAttribute("data-customer-id");

    const wishlistModalCloseButton = document.getElementById(`ModalClose-${variantId}`);

    var url = `/a/account/${customerId}/cellar_items/create_wishlist_item`;
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
          if(xhr.status === 400) {
            const responseJSON = JSON.parse(xhr.response);
            const errorsEl = document.getElementById(`product-cellar-item__errors-${variantId}`);
            errorsEl.style.display = "block";
            console.log(responseJSON.error);
            wishlistErrorsEl.innerHTML = "Could not save product to your Cellar";
          } else if(xhr.status === 200) {
            const wishlistAddButton = document.getElementById(`product-cellar-item__add-button-${variantId}`);
            const wishlistRemoveButton = document.getElementById(`product-cellar-item__remove-button-${variantId}`);
            wishlistAddButton.style.display = "none";
            wishlistRemoveButton.style.display = "flex";
          }
          
          // Close Modal
          wishlistModalCloseButton.click();
      }};
    
    const wishlistSaveForm = document.getElementById(`product-cellar-item__save-form-${variantId}`);
    const formData = new FormData(wishlistSaveForm);
    const categoryId = formData.get('cellar_category_id');

    const data = `{
      "cellar_category_id": ${categoryId},
      "shopify_variant_id": ${variantId}
    }`;

    xhr.send(data);

  }

});